export default {
	title: "Topics",
	categoryLabel: "Topic Category",
	addTopicButton: "Add&nbsp;topic",
};
